import { render, staticRenderFns } from "./OverdueExplanationScreen.vue?vue&type=template&id=a39b6c66&scoped=true&"
import script from "./OverdueExplanationScreen.vue?vue&type=script&lang=js&"
export * from "./OverdueExplanationScreen.vue?vue&type=script&lang=js&"
import style0 from "./OverdueExplanationScreen.vue?vue&type=style&index=0&id=a39b6c66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39b6c66",
  null
  
)

export default component.exports